import Vue from 'vue'
import ElementUI from 'element-ui'
import './assets/el-theme/dark/theme/index.css'
// import './assets/el-theme/white/theme/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
import LiquorTree from 'liquor-tree'
import vFullscreen from 'vue-fullscreen'
import VueMousetrap from 'vue-mousetrap'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios';
import chalk from 'chalk'
import vmodal from 'vue-js-modal' // document: https://euvl.github.io/vue-js-modal/
import App from './App.vue'
import icon from './components/common/icon/icon.vue'
import './assets/iconfont.js'
import hitab from 'hitab'
import api from './api'
import model from './model'
import env from './env'
import utils from './utils'

import tabBadgeRed from './components/tab/tabBadgeRed'
import tabBadgeBlue from './components/tab/tabBadgeBlue'
import tabBadgeGreen from './components/tab/tabBadgeGreen'
import tabBadgeYellow from './components/tab/tabBadgeYellow'

// fonts
import "./styles/index.css"
import "./styles/element-customize.css"
import "./assets/fonts/fira/fira_code.css"
import "./assets/fonts/iosevka-term/iosevka-term.css"
import "./assets/fonts/source-code-pro/source-code-pro.css"
import "./assets/fonts/jetbrains-mono/jetbrains-mono.css"

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(LiquorTree)
Vue.use(vFullscreen)
Vue.use(VueMousetrap)
Vue.use(hitab)
Vue.use(VueAxios, axios)
Vue.use(vmodal)
Vue.use(VueAuthenticate, {
  baseUrl: '/api/v1/oauth2', // Your API domain, 授权之后将授权信息(clientId/code/redirectUri) 返回给后端
  
  providers: {
    github: {
      clientId: '38f78ef0292ed7fa4129', // client ID, 在 github 中开通的 Oauth App 申请
      redirectUri: 'https://auth.watsess.com/api/v1/oauth2/redirect/github' // Your client app URL, 授权成功后, github 对这个网址发起 GET 请求, 在 query 中带上 code
    }
  }
})
Vue.prototype.api = api
Vue.prototype.model = model
Vue.prototype.env = env
Vue.prototype.utils = utils
Vue.prototype.isAdmin = JSON.parse(localStorage.getItem('isAdmin'))
Vue.prototype.chalk = new chalk.Instance({enabled: true, level: 2})
Vue.component('icon', icon)
Vue.component('tab-badge-red', tabBadgeRed)
Vue.component('tab-badge-blue', tabBadgeBlue)
Vue.component('tab-badge-green', tabBadgeGreen)
Vue.component('tab-badge-yellow', tabBadgeYellow)

// utils.hotKey.init()

new Vue({
  render: h => h(App),
}).$mount('#app')
